import img1 from './consultorio-01.69dcb74b.JPG';
import img2 from './consultorio-02.c527e480.JPG';
import img3 from './consultorio-03.a779bb1c.JPG';
import img4 from './consultorio-04.5198b973.JPG';
import img5 from './consultorio-05.56f7687b.JPG';
import img6 from './consultorio-06.686e3435.JPG';
import img7 from './consultorio-07.b620e0b0.JPG';

interface Photo {
  src: string;
  width: number;
  height: number;
}

const photos: Photo[] = [
  { src: img1, width: 1.3333333333333333, height: 1 },
  { src: img2, width: 1.3333333333333333, height: 1 },
  { src: img3, width: 1.3333333333333333, height: 1 },
  { src: img4, width: 1.3333333333333333, height: 1 },
  { src: img5, width: 1.3333333333333333, height: 1 },
  { src: img6, width: 1.3333333333333333, height: 1 },
  { src: img7, width: 1.3333333333333333, height: 1 },
];

export default photos;
